var data = {
	"body": "<g fill=\"none\"><path d=\"M3 6h18M3 12h18M3 18h18\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></g>",
	"width": 24,
	"height": 24
};
export default data;
